import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const textStyle = css`
  margin: 0;
  margin-bottom: ${theme.spacing(2)};
  max-width: 600px;
`;

export const containerStyle = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  padding: ${theme.spacing(2)};
  height: 100%;
`;

export const headingStyle = css`
  color: ${theme.colors.text.subdued};
  margin: 0;
  margin-bottom: ${theme.spacing(1)};
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: center;
`;

export const imageStyle = css`
  display: block;
  margin: 0 auto;
  height: 350px;
  margin-bottom: ${theme.spacing(2)};
`;
